import { TrackJS } from 'trackjs';
import { AppConfig } from '@ve/types';

interface ExWindow extends Window {
    appConfig: AppConfig
}

declare let window: ExWindow;

export default (): string => {
    const showcasePath = window.appConfig?.showcasePath;

    if (!showcasePath) {
        TrackJS.track('showcasePath is not defined');

        return '';
    }

    return showcasePath.replace(/\/+$/, '');
};
